import { render, staticRenderFns } from "./AvailabilityReservation.vue?vue&type=template&id=04b590f2"
import script from "./AvailabilityReservation.vue?vue&type=script&lang=js"
export * from "./AvailabilityReservation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports